module.exports = __webpack_public_path__ + "static/media/icon_search.7dbcc5ef.svg";